module.exports = __webpack_public_path__ + "img/classify-item3.d7defdc4.png";